/**
 * mc library
 */

import _ from "underscore";
import * as d3 from "d3";
import µ from "../../earth/1.0.0/micro";
import * as THREE from "three";
import mcOverlayWorld from "./mc-overlay-world"
import mcEarthImage from "./mc-overlay-earthImage"
import mcOverlayCrossSection from "./mc-overlay-cs3d"


export default (function(canvas, configuration, inputController) {

    var VIEW_RATE = 1.0;

    var renderer, scene, camera;
    var quickOverlayScale;
    var overlayWorld;
    var overlayCrossSection;
    var overlayEarthImage;
    var imageReloadFlag;

    var parentView = µ.view();
    var container = canvas; //d3.select("#quickoverlay");



    function checkWebGL(canvas){
        var gl;

        try {
            gl = canvas.node().getContext("webgl");
        } catch (e) {}

        if (!gl) {
            try {
                gl = canvas.node().getContext("experimental-webgl");
            } catch (e) {}
        }

        return gl || undefined;
    }

    function cameraDegree(rotate){
        let phi = THREE.Math.degToRad(90 - rotate[1]);
        let theta = THREE.Math.degToRad(rotate[0]);

        return {phi:phi, theta:theta};
    }

    function cameraPosition(){
        let rotate = inputController.globe().projection.rotate();
        let phi = cameraDegree(rotate).phi;
        let theta = cameraDegree(rotate).theta;

        return {
            x: 16001 * Math.sin(phi) * Math.cos(theta),
            y: -16001 * Math.cos(phi),
            z: 16001 * Math.sin(phi) * Math.sin(theta)
        }
    }

    function clearResource(){
        if(renderer){
            renderer.setAnimationLoop(null);
        }

        // clearColor();
        if(renderer){
            renderer.clear();
        }

        // if(overlayWind){
        // 	overlayWind.clear();
        // 	overlayWind = undefined;
        // }

        if(overlayCrossSection){
            overlayCrossSection.clear();
            overlayCrossSection = undefined;
        }

        if(overlayWorld){
            overlayWorld.clear();
            overlayWorld = undefined;
        };

        if(overlayEarthImage){
            overlayEarthImage.clear();
            overlayEarthImage = undefined;
            imageReloadFlag = true;
        };

        if(scene && scene.children && scene.children.length > 0){
            while(scene.children.length > 0){
                scene.remove(scene.children[0]);
            }
        }
        //
        if(scene){
            scene.dispose();
            scene = undefined;
        }
        //
        if(camera){
            // 	camera.dispose();
            camera = undefined;
        }

        if(renderer){
            renderer.dispose();
            renderer = undefined;
        }
    }

    function clearCrossSection(){
        if(overlayCrossSection){
            overlayCrossSection.clear();
            quickRender();
        }
    }

    function init(){
        if(renderer !== undefined) return;
        imageReloadFlag = true;
        var context = checkWebGL(container);


        renderer = new THREE.WebGLRenderer({canvas: container.node(), context: context, antialias: true});
        renderer.setPixelRatio(1);
        renderer.setSize(container.width, container.height);
        camera = new THREE.OrthographicCamera(-container.width/2*VIEW_RATE, container.width/2*VIEW_RATE, container.height/2*VIEW_RATE, -container.height/2*VIEW_RATE, 0.1, 30000);
        scene = new THREE.Scene();

        camera.position.z = 3001;
        scene.add(camera);

        let initScale = inputController.globe().projection.scale();
        //added by shson, 날씨변수 오버레이 추가
        quickOverlayScale = d3.scaleLinear().domain([0, initScale]).range([0, 1]);
        overlayWorld = mcOverlayWorld(scene, initScale);
        overlayEarthImage = mcEarthImage(scene, initScale);
        overlayCrossSection = mcOverlayCrossSection(scene, initScale);

    }

    function quickRender() {
        if(renderer === undefined || camera === undefined) return;
        // camera.position.x = cameraPosition().x;
        // camera.position.y = cameraPosition().y;
        // camera.position.z = cameraPosition().z;
        // camera.lookAt(scene.position);
        camera.updateProjectionMatrix();
        // camera.zoom = quickOverlayScale(inputController.globe().projection.scale());

        let gl = checkWebGL(container);
        gl.enable(gl.BLEND);
        gl.disable(gl.STENCIL_TEST);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        var currentRotate = inputController.globe().projection.rotate();
        var currentScale = inputController.globe().projection.scale();
        overlayEarthImage.moveOverlay(currentRotate, quickOverlayScale(currentScale));
        overlayWorld.moveOverlay(currentRotate, quickOverlayScale(currentScale));
        overlayCrossSection.moveOverlay(currentRotate, quickOverlayScale(currentScale));
        renderer.render(scene, camera);
        gl.disable(gl.BLEND);
    }

    function renderCrossSection(crossSectionData, overlayGrid, scale){
        if(overlayCrossSection){
            overlayCrossSection.clear();
            overlayCrossSection.render(crossSectionData, scale, overlayGrid.binaryScale === undefined ? 1. : overlayGrid.binaryScale, quickRender);
        }
    }

    return {
        render: function render(quickoverlayEnabled, grids){
            if(!checkWebGL(container)) return false;

            if(!quickoverlayEnabled) {
                clearResource();
                return false;
            }

            let changed = _.keys(configuration.changedAttributes());
            let orientationchanged = configuration.get("orientationchanged"); // device orientation changed
            if(orientationchanged){
                renderer.setPixelRatio(1);
                renderer.setSize(container.width, container.height);
                camera.left = -container.width/2*VIEW_RATE;
                camera.right = container.width/2*VIEW_RATE;
                camera.top = container.height/2*VIEW_RATE;
                camera.bottom = -container.height/2*VIEW_RATE;
                configuration.save({orientationchanged: false});
            }
            if (changed.length === 1 && _.intersection(changed, ["orientation"]).length > 0) return;

            // initialize renderer, camera, scene, overlay
            init();

            if (_.intersection(changed, ["overlayType"]).length > 0) {
                overlayWorld.clear();
            }

            if (imageReloadFlag === true) overlayEarthImage.render(grids, quickRender);
            imageReloadFlag = false;

            overlayWorld.render(grids, quickRender);

            return true;
        },
        changeWebGlCanvas: function changeWebGlCanvas(){
            parentView = µ.view();
            container.width = parentView.width;
            container.height = parentView.height;
        },
        checkWebGL: checkWebGL,
        quickRender: quickRender,
        clearResource: clearResource,
        clearCrossSection: clearCrossSection,
        renderCrossSection: renderCrossSection,
    };

});
